import { useTranslation } from 'react-i18next';
import { Sparkles } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { useAssistantPanel } from '@/contexts/AssistantContext';

// Header entry point. Only rendered for users with the `ai_assistant` feature.
export function AssistantToggleButton() {
  const { t } = useTranslation();
  const { open, toggle } = useAssistantPanel();
  return (
    <Button
      variant={open ? 'secondary' : 'ghost'}
      size="sm"
      onClick={toggle}
      aria-pressed={open}
      aria-label={open ? t('aiAssistant.close') : t('aiAssistant.open')}
      title={t('aiAssistant.title')}
      className={cn('gap-1.5 px-2', open && 'text-primary')}
      data-testid="assistant-toggle"
    >
      <Sparkles className="h-4 w-4" />
      <span className="hidden text-xs font-medium md:inline">{t('aiAssistant.short')}</span>
    </Button>
  );
}
